import LabelWithProperty from '@/components/BaseLabel/LabelWithProperty';
import PropertyValue from '@/components/Typography/PropertyValue';
import { UNCATEGORIZED_LABEL } from '@/configs/reserved-word';
import useCategoryMap from '@/hooks/domain/useCategoryMap';
import type { CATEGORY_TYPE } from '@/types/categoryConst';
import { isEmptyArray } from '@/utils/util';

import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const CategoryField = (
  props: CommonFieldProps & {
    classification: CATEGORY_TYPE[];
  },
) => {
  const currentCategoryMap = useCategoryMap();

  if (!props.showFull && isEmptyArray(props.classification)) return null;

  return (
    <PropertyRowWrapper {...props} expandable>
      {props.classification && props.classification.length > 0 ? (
        props.classification.map((key) => {
          const category = currentCategoryMap[key];
          if (!category) return null;
          return (
            <LabelWithProperty
              key={key}
              color={category.color}
              name={category.name}
            />
          );
        })
      ) : (
        <PropertyValue value={UNCATEGORIZED_LABEL} />
      )}
    </PropertyRowWrapper>
  );
};
